// extracted by mini-css-extract-plugin
module.exports = {"email":"Email_email__WALz0","valid":"Email_valid__AYDJK","invalid":"Email_invalid__p64iY"};